import { appConfig } from '../service/config';
import { router } from '../service/router';

export class NavBrandLogo extends HTMLElement {
  connectedCallback(): void {
    if (appConfig.core && appConfig.core.defaultRoute) {
      this.addEventListener('click', () => {
        router.navigateTo(appConfig.core.defaultRoute);
      });
    }
  }
}

window.customElements.define('nav-brand-logo', NavBrandLogo);
